import React from 'react';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import cn from '../../../../lib/bem';
import ico_exito from './../../../../assets/icons/ico_exito.svg';
import ButtonComponent from '../../../../components/button/button_component';

import './consuRescaRegExito.scss';

const ConsuRescaRegExito = () => {
    
    const history = useNavigate();
    const classes  = cn("consuRescaRegExito");

    const endosoPoliza  = useSelector((state) => state.rootReducers.endosoPoliza);
 
    return (
        <div className={classes()}>
           <div className={classes('container')}>
                <img src={ico_exito} alt='exito' />
                <p><b>¡Tu solicitud ha sido registrada con &eacute;xito!</b></p>
                <br/>
                <p>
                    Tu solicitud ha sido registrada con &eacute;xito con el n&uacute;mero de atenci&oacute;n { endosoPoliza.numeroSolicitudServicio }. Te estaremos confirmando por correo electr&oacute;nico cuando inicie el proceso de abono en tu cuenta. Recuerda que una vez abonado el monto de rescate en tu cuenta la p&oacute;liza ya se encontrar&iacute;a inactiva.
                </p>
                <br/>
                <div className={classes('btnContinuarExito')}>
                    <ButtonComponent label={'btnContinuar'} nombre={'Continuar'} tipo={'button-red'} action={() => history('/')} disabled={false}/>
                </div>
           </div>
        </div>
    );
};

export default ConsuRescaRegExito;
